export function isSuperAdminEmail(email: string): boolean {
  if (!email) return false
  return email === process.env.REACT_APP_ADMIN_EMAIL
}
